import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';
import authService from 'src/services/authService';
import PropTypes from 'prop-types';

export function AuthGuard({ children }) {
  const location = useLocation();
  const account = useSelector((state) => state.account);

  if (!authService.isAuthenticated()) {
    return <Redirect to="/login" />;
  }

  if (account.user?.changePassword && location.pathname !== '/change-password') {
    return <Redirect to="/change-password" />;
  }

  return children;
}

AuthGuard.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export default AuthGuard;
